
<script>

  import { Bar } from 'vue-chartjs'

  export default {
    extends: Bar,
    props: {
      highestYValue: {
        type: Number,
        default: undefined,
      },
      movement: {
        type: String,
        default: 'in',
      },
      branch: {
        type: Object,
        default: undefined,
      },
      data: {
        type: Array,
        default: () => {
          return [{
                    label: 'After',
                    data: [],
                    order: 1,
                  },
                  {
                    label: 'Before',
                    data: [],
                    order: 0,
                  }] 
        },
      },
      labels: {
        type: Array,
        default: () => {
          return []
        },
      },

    },
    data () {
      return {
        options: {
          legend: {
            onClick: null,
          }, 
          tooltips: {
            callbacks: {
              label: this.computeLabel,
            },         
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{ stacked: true }],
            yAxes: [{ 
              stacked: true,
              ticks: {
                max: 0,
              }, 
            }],
          },
        },

      }
    },
    computed: {
      dynamicOptions () {
        let options = this.options
        options.scales.yAxes[0].ticks.max = this.highestYValue
        return options
      },
    },
    watch: {
      data: {
        handler (value) {
          if (value) {
            this.renderChart({
              labels: this.labels,
              datasets: this.getData(),    
            }, this.dynamicOptions)
          }
        },
      },
      highestYValue: {
        handler (value) {
          if (value) {
            this.renderChart({
              labels: this.labels,
              datasets: this.getData(),    
            }, this.dynamicOptions)
          }
        },
      },
    },
    mounted () {   

    },
    methods: {
      computeLabel (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || ''

        if (label) {
          label += ': '
        }

        let displayValue = 0
      
        if (this.movement === 'in') {
          let isAfter = tooltipItem.datasetIndex === 0
          displayValue = isAfter ? data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + data.datasets[1].data[tooltipItem.index] : data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        } else {
          let isBefore = tooltipItem.datasetIndex === 1
          displayValue = isBefore ? data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + data.datasets[0].data[tooltipItem.index] : data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        }

        label += Math.round(displayValue * 100) / 100
        return label
      },
      getData () {
        let data = [...this.data]
        if (this.movement === 'in') {
          data[0].backgroundColor = '#68ed9d'
        } else {
          data[0].backgroundColor = '#f87979'
        }

        return data
      },
    
    },
  }
</script>
